var label = '间距';
var name = 'div';
export default {
  icon: 'icon-space',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      wrap: {
        show: false
      },
      native: false,
      style: {
        width: '100%',
        height: '20px'
      },
      children: []
    };
  },
  props: function props() {
    return [{
      type: 'object',
      field: 'formCreateStyle',
      native: true,
      props: {
        rule: [{
          type: 'input',
          field: 'height',
          title: 'height'
        }]
      }
    }];
  }
};